import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class UpdateCompanyBankRulesCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) { }

  async run(company_id:String|Number, debit_rules:string, credit_rules:string): Promise<any> {
    let args = { 
      company_id: company_id,
      debit_rules: debit_rules,      
      credit_rules: credit_rules,
    }    
    let res = await this.dispatcher.dispatch('update.company.bank_rules', args);    
  }
}